import { Pipe, type PipeTransform } from '@angular/core';

// This pipe should not be here in the lessons, refactor when is posible and remove LangCodeDescription
export const LangCodeDescription = {
  es: 'Spanish',
  en: 'English',
  it: 'Italian',
  pt: 'Portuguese',
  fr: 'French',
  ja: 'Japanese',
};

export const LangCodeDescriptionEs = {
  es: 'Español',
  en: 'Inglés',
  it: 'Italiano',
  pt: 'Portugués',
  fr: 'Frances',
  ja: 'Japonés',
};

@Pipe({
  name: 'langDesc',
  standalone: true,
})
export class LangDescTranslationPipe implements PipeTransform {
  transform(value: string, lang: string): boolean {
    if (lang === 'es') {
      return LangCodeDescriptionEs[value];
    } else {
      return LangCodeDescription[value];
    }
  }
}

@Pipe({
  name: 'flagEmoji',
  standalone: true,
})
export class FlagLanguagePipe implements PipeTransform {
  transform(lang: string): string {
    if (lang === 'en') {
      return '🇺🇸';
    } else if (lang === 'es') {
      return '🇲🇽';
    } else if (lang === 'fr') {
      return '🇫🇷';
    } else if (lang === 'it') {
      return '🇮🇹';
    } else if (lang === 'pt') {
      return '🇧🇷';
    } else {
      return '';
    }
  }
}
